import { render, staticRenderFns } from "./FullPageDigiStudentProfile.vue?vue&type=template&id=3bd303c0&"
import script from "./FullPageDigiStudentProfile.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiStudentProfile.vue?vue&type=script&lang=js&"
import style0 from "./FullPageDigiStudentProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports